import React, { MouseEventHandler } from 'react'
import { LinkBtn } from '@manychat/manyui'

import If from 'components/If/If'

import { PreviewBlocksAvatar } from './PreviewBlocksAvatar'

interface BlockProps {
  title: string
  info: string
  dataTestId?: string
  isHasLeftMargin?: boolean
}

export const Block = (props: BlockProps) => {
  return (
    <div className={props.isHasLeftMargin ? 'm-b m-l-xl p-l' : 'm-b'}>
      <span className="text-subheading d-block text-black font-semibold">{props.title}</span>
      <span className="d-block">{props.info}</span>
    </div>
  )
}

interface AvatarButtonBlockProps {
  title: string
  info: string
  avatar?: string
  btn?: {
    name: string
    url?: string
  }
  dataTestId?: string
  onBtnClick?: MouseEventHandler
  children?: React.ReactNode
}

export const AvatarButtonBlock = (props: AvatarButtonBlockProps) => {
  return (
    <div data-test-id={props.dataTestId} className="d-flex m-b">
      <PreviewBlocksAvatar url={props.avatar} />
      <div style={{ width: '100%' }} className="p-a-xxs m-l-xs">
        <span className="text-subheading d-block font-semibold">{props.title}</span>
        <span className="d-block">{props.info}</span>
        <If condition={Boolean(props.children)}>
          <div>{props.children}</div>
        </If>
        <If condition={Boolean(props.btn)}>
          <LinkBtn
            className="m-t"
            label={props.btn?.name}
            fullWidth
            variant="default"
            href={props.btn?.url}
            target="_blank"
            onClick={props.onBtnClick}
          />
        </If>
      </div>
    </div>
  )
}
interface ButtonBlockProps {
  title: string
  info: string
  btn?: {
    name: string
    url: string
  }
  dataTestId?: string
  isHasLeftMargin?: boolean
}

export const ButtonBlock = (props: ButtonBlockProps) => {
  return (
    <div
      data-test-id={props.dataTestId}
      className={props.isHasLeftMargin ? 'm-b m-l-xl p-l' : 'm-b'}
    >
      <span className="text-subheading d-block text-black font-semibold">{props.title}</span>
      <span className="d-block">{props.info}</span>
      <If condition={Boolean(props.btn)}>
        <LinkBtn
          className="m-t"
          label={props.btn?.name}
          fullWidth
          variant="default"
          href={props.btn?.url}
          target="_blank"
          onClick={(event) => event.stopPropagation()}
        />
      </If>
    </div>
  )
}
